import React from "react";
import { connect } from 'react-redux';
import { stravaAuthFetch, stravaRefreshTokenToAccessToken, stravaUnpair } from '../actions';

import { CSVLink} from "react-csv";
import googlePlay from '../assets/img/google-play-badge.png'

import {
  Card,
  CardHeader,
  CardFooter,
  Row,
  Col,
  Button,
  Input,
} from "reactstrap";


import {stravaAuth, splitUrl} from '../helperFunctions/stravaAuth'

import NotificationAlert from "react-notification-alert";


const buttonStyle = {
    width: '70px',
    height: '30px',
    padding: '6px 0px',
    borderRadius: '5px',
    fontSize: '12px',
    lineHeight: '1.42857',
    marginTop:'10px'
    
}
class ImportExport extends React.Component {
  
    state = {stravaConnected:this.props.auth.strava_connected ? 'Linked' : 'Not Linked',numberActivities:200}
    
    notify(place,message) {
        if (!message){
          return ""
        }
        var color = message[0];
        if (color === "logout"){
          localStorage.clear()
          window.location.replace("/login")
        }
        var type;
        switch (color) {
          case 'success':
            type = "success";
            break;
          case 'danger':
            type = "danger";
            break;
          case 'warning':
            type = "warning";
            break;
          default:
            break;
        }
        var options = {};
        options = {
          place: place,
          message: (
            <div>
              <div style={{height:'70px'}}>
                {message[1]}
              </div>
              
            </div>
          ),
          type: type,
          icon: "now-ui-icons ui-1_bell-53",
          autoDismiss: 10,
        };
        this.refs.notificationAlert.notificationAlert(options);
      }
    componentDidMount(){
        if (!localStorage.getItem("token")){
        window.location.replace("/login")
        }
        if (window.location.href.includes('code')){
            this.props.stravaAuthFetch(splitUrl(window.location.href))
        }
        else{
            ///console.log("yeyeyeye")
        }
    }
    componentDidUpdate(prevProps){
        if(prevProps.message.message !== this.props.message.message && this.props.message.message){
            this.notify("br",this.props.message.message)
        }
    }
    changeActivityDuration = (value) => {
        this.setState({activityDuration:value})
    }
  
    syncStrava = () => {
      var pages = Math.floor(this.state.numberActivities/200)
      const remainder = this.state.numberActivities%200
      if (remainder>0){
        pages ++
      }
      for (var i = 1;i<=pages;i++){
        this.props.stravaRefreshTokenToAccessToken(this.props.auth.strava_refresh_token,i)
      }
        
    }
    
  
  render() {
    
    //console.log(this.props.auth.strava_connected)
    
    //const loca  = localStorage.getItem('user')
    //const [runningIndex,dates]=runningIndexList(this.props.activities.entries)
    const csvData = [
      ["date", "duration", "distance","avgHr","ascent","descent","//"],
    ];
    
    for (var i=0;i<this.props.activities.entries.length;i++){
      var date = this.props.activities.entries[i].date
      date = date.split(" ")
      date = date[1]+" "+date[2]+" "+date[3]
      const duration = this.props.activities.entries[i].duration
      const distance = this.props.activities.entries[i].distance
      const avgHr = this.props.activities.entries[i].avgHr
      const ascent = this.props.activities.entries[i].ascent
      const descent = this.props.activities.entries[i].descent
      const activity = [date,duration,distance,avgHr,ascent,descent,0]
      csvData.push(activity)
    }

    return (
      <>
        <div className="content" style={{marginTop:'40px'}}>
          <h4 style={{color:'rgb(240,240,240)'}}>Import/Export</h4>
          <p className="category"></p>
            
            <NotificationAlert ref="notificationAlert" />
            <Row style={{marginTop:'40px'}}>
                <Col xs={12} md={12}>
                <Card className="card-chart" style={{backgroundColor: '#444444',color: '#FFFFFF'}}>
                    <CardHeader>
                    <h5 className="card-category"  style={{color: '#FFFFFF'}}>Import From Strava</h5>
                    {this.props.auth.strava_connected ? 
                    <Row>
                    <Col className="hoverButton">
                    <Button style={{backgroundColor:'rgb(100,255,100)'}} onClick={this.syncStrava}>Sync Activities</Button> 
                    <label className='text-white'>Sync last {this.state.numberActivities} activities</label>
                    <Input type='number' style={{width:'70px'}} value={this.state.numberActivities} onChange={(e)=>this.setState({numberActivities:e.target.value})}/>
                    </Col>
                     </Row>
                    :  <p style={{color:'rgb(255,150,150)'}}>Link to strava first</p>}

                    
                    </CardHeader>
                    <CardFooter>
                        <div className="stats">
                        <Row>
                          <Col xs={12} sm={2} className="hoverButton">
                            <button onClick={stravaAuth} type="button" class="btn btn-warning" style={buttonStyle}><i class="fab fa-strava" style={{padding:'0px 8px',marginLeft:'3px',marginBottom:'3px'}}></i></button><p>Status: {this.props.auth.strava_connected ? "Linked" : "Not Linked"}</p>
                          </Col>
                          <Col xs={12} sm={1}>
                            {this.props.auth.strava_connected ?
                             <Button style={{backgroundColor:'rgb(255,100,100)',width: '30px',height: '30px',padding: '6px 0px',borderRadius: '5px',fontSize: '12px',lineHeight: '1.42857',marginTop:'10px'}} onClick={this.props.stravaUnpair}><i class="fas fa-times" style={{padding:'0px 8px',marginLeft:'3px',marginBottom:'3px'}}></i></Button>
                              : ''}
                          </Col>
                          
                        </Row>
                        <Row>
                          <Col>
                            <p className='text-danger'>Before importing make sure your max heart rate,rest heart rate and lactate are set to correct values</p>
                          </Col>
                        </Row>
                        
                        
                        </div>
                    </CardFooter>
                </Card>
                </Col>
                
            </Row>
            <Row style={{marginTop:'40px'}}>
                <Col xs={4} md={4}>
                      <a href='https://play.google.com/store/apps/details?id=net.leadingpace.twa'><img src={googlePlay}></img></a>
                </Col>
                
            </Row>
            <Row style={{marginTop:'40px'}}>
                <Col xs={12} md={12}>
                <Card className="card-chart" style={{backgroundColor: '#444444',color: '#FFFFFF'}}>
                    <CardHeader>
                    <h5 className="card-category"  style={{color: '#FFFFFF'}}>Download csv</h5>
                      <Button style={{backgroundColor:'rgb(10,10,10)'}}><CSVLink data={csvData}>Download csv</CSVLink></Button>
                      
                      
                    </CardHeader>
                    <CardFooter>
                        <div className="stats">
                        <Row>
                       
                          
                        </Row>
                        
                        
                        </div>
                    </CardFooter>
                </Card>
                </Col>
                
            </Row>
    
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  //console.log("map",state)
  return {auth:state.auth,message:state.message,activities:state.activities}
}

export default connect(mapStateToProps,{stravaAuthFetch, stravaRefreshTokenToAccessToken, stravaUnpair})(ImportExport);
